const colors = {
  primary: "#191919",
  primaryLight: "#1919194a",
  accent: "var(--color-brand-70)",
  accentHover: "#E67A00",
  accentDisabled: "rgba(247, 138, 5, 0.5)",
  secondary: "var(--color-fg-3)",
  border: "var(--color-stroke-subtle)",
  borderDark: "#191919",
  background: "var(--color-surface)",
  backgroundLight: "var(--color-surface-subtle)",
  backgroundOverlay: "rgba(255,255,255,.5)",
  success: "var(--color-status-success-fill)",
  error: "var(--color-fg-danger-soft)",
  warning: "orange",
  textPrimary: "#191919",
  textSecondary: "var(--color-fg-2)",
  textDisabled: "var(--color-fg-disabled)",
  textOnAccent: "var(--color-accent-foreground)",
};

const spacing = {
  none: "0px",
  xxs: "4px",
  xs: "8px",
  sm: "10px",
  md: "12px",
  lg: "12px",
  xl: "16px",
  xxl: "20px",
  xxxl: "24px",
};

const typography = {
  fontSizeXs: "12px",
  fontSizeSm: "14px",
  fontSizeMd: "15px",
  fontSizeLg: "16px",
  fontSizeXl: "20px",
  fontSizeXxl: "24px",
  lineHeightSm: "16px",
  lineHeightMd: "20px",
  lineHeightLg: "28px",
  fontWeightNormal: 400,
  fontWeightSemibold: 600,
};

export const Styles: any = {
  "icon16pxContainer": { width: "16px", height: "16px" },
  "textFieldWidth": {
    width: "296px",
  },
  "fontBold": {
    root: {
      fontWeight: typography.fontWeightSemibold,
      fontSize: typography.fontSizeMd,
    },
  },
  "searchableDropdownStyles": {
    root: {
      borderColor: `${colors.border} !important`,
      selectors: {
        ":active, :hover, :focus": {
          borderColor: `${colors.border} !important`,
        },
        "::after": {
          borderColor: `${colors.border} !important`,
        },
      },
    },
  },
  "reactSelect": (theme: Record<string, unknown> & { colors: Record<string, string> }) => {
    return {
      ...theme,
      borderRadius: 2,
      colors: {
        ...theme.colors,
        primary25: colors.backgroundLight,
        primary: colors.accent,
      },
    };
  },
  "textFieldMaxWidth": {
    maxWidth: "296px",
  },
  "textField400": {
    maxWidth: "400px",
  },
  "verticallyCentredSpinner": {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 999,
  },
  "verticallyCentredSpinnerWrapper": {
    width: "100%",
    height: "100%",
    position: "fixed",
    left: 0,
    top: 0,
    background: colors.backgroundOverlay,
    zIndex: 1000,
  },
  "absolutelyCentredSpinner": {
    position: "absolute",
    top: "50%",
    left: "50%",
    zIndex: 999,
  },
  "mainContainerStyle": {
    root: {
      background: colors.background,
      padding: spacing.xxxl,
      height: "auto",
    },
  },
  "predictionMainContainerStyles": (height: string | number) => ({
    root: {
      background: colors.background,
      padding: spacing.xxxl,
      height: height,
    },
  }),
  "mainHeadingStyle": {
    fontWeight: typography.fontWeightSemibold,
    fontSize: typography.fontSizeXxl,
    lineHeight: typography.lineHeightLg,
    display: "flex",
    alignItems: "center",
    color: colors.textPrimary,
  },
  "flexJustifyEnd": {
    display: "flex",
    justifyContent: "flex-end",
  },
  "buttonIconClass": {
    root: {
      "fontSize": typography.fontSizeXs,
      "color": `${colors.textPrimary} !important`,
      ":hover": {
        color: `${colors.textPrimary} !important`,
      },
    },
  },

  "ellipsisStyle": {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    minWidth: "0px",
    maxWidth: "100%",
    overflowWrap: "break-word",
    margin: "1px",
  },
  "mainHeadingSize": {
    fontSize: typography.fontSizeLg,
    fontWeight: typography.fontWeightSemibold,
    color: colors.textPrimary,
  },
  "mainHeight": {
    marginTop: "5px",
    color: colors.textPrimary,
  },

  "subHeadingStyle": {
    fontStyle: "normal",
    fontWeight: typography.fontWeightSemibold,
    fontSize: typography.fontSizeSm,
    lineHeight: typography.lineHeightSm,
    color: colors.textSecondary,
    display: "inline",
  },
  "mainHeadingWeight": {
    fontWeight: typography.fontWeightSemibold,
    color: colors.textPrimary,
  },
  "subHeadingWeight": {
    fontWeight: typography.fontWeightSemibold,
    color: colors.textSecondary,
  },
  "breadcrumb": {
    root: {
      margin: "0px, 0px, 16px, 0px",
      marginBottom: spacing.lg,
      span: {
        lineHeight: typography.lineHeightMd,
        fontSize: typography.fontSizeSm,
      },
      button: {
        "lineHeight": typography.lineHeightMd,
        "fontSize": typography.fontSizeSm,
        ":hover": {
          background: "none",
        },
      },
    },
  },
  "warningicon": {
    color: colors.warning,
    fontSize: 20,
    marginRight: "5px",
  },
  "commonIconClass": {
    fontSize: typography.fontSizeMd,
    color: `${colors.textPrimary} !important`,
    lineHeight: "unset",
    display: "flex",
  },
  "panel": {
    root: {
      minHeight: "calc( 100vh - 90px )",
    },
  },
  "panelSave": {
    root: {
      "height": "32px",
      "borderRadius": "2px",
      "border": "none",
      "background": colors.accent,
      "color": colors.textOnAccent,
      "marginRight": spacing.xs,
      ":hover": {
        background: `${colors.accent} !important`,
      },
    },
    rootDisabled: {
      "cursor": "not-allowed !important",
      "color": colors.textOnAccent,
      "background": colors.accentDisabled,
      ":hover": {
        background: colors.accentDisabled,
      },
    },
  },
  "validateCredentialsButton": {
    root: {
      "height": "32px",
      "borderRadius": "2px",
      "border": "none",
      "background": colors.accent,
      "color": colors.textOnAccent,
      "marginRight": spacing.xs,
      ":hover": {
        background: `${colors.accent} !important`,
      },
      "width": "200px",
    },
    rootDisabled: {
      "cursor": "not-allowed !important",
      "color": colors.textOnAccent,
      "width": "200px",
      "background": colors.accentDisabled,
      ":hover": {
        background: colors.accentDisabled,
      },
    },
  },
  "panelCancel": {
    root: {
      "height": "32px",
      "borderRadius": "2px",
      "border": `1px solid ${colors.secondary}`,
      ":hover": {
        background: `${colors.background} !important`,
      },
    },
  },
  "panelFooter": {
    justifyContent: "flex-end",
    height: "65px",
    alignItems: "center",
    backgroundColor: colors.background,
    padding: `${spacing.sm} 0`,
    position: "absolute" as const,
    bottom: "0px",
    right: "28px",
    width: "100%",
  },
  "rootPanel": {
    root: {
      ".ms-Panel-closeButton": {
        color: colors.textPrimary,
        marginRight: "25px",
      },
      ".ms-Panel-commands": {
        backgroundColor: "rgba(255, 255, 255, 1)",
        zIndex: 999,
      },
      ".ms-TextField-fieldGroup": {
        border: `1px solid ${colors.borderDark}`,
      },
      ".ms-Panel-content": {
        paddingBottom: "80px",
        marginTop: spacing.xxxl,
      },
      ".ms-Dropdown, .ms-Dropdown-title": {
        borderColor: colors.borderDark,
      },
    },
    headerText: {
      fontSize: typography.fontSizeXxl,
    },
    scrollableContent: {},
    content: {
      root: {
        padding: "0 28px 80px 28px",
      },
    },
    footer: {
      root: {
        padding: "0 28px",
      },
    },
  },
  "spinner": {
    root: {
      "height": "36px",
      "zIndex": "12px",
      "marginTop": "-38px",
      "background": `${colors.backgroundLight} !important`,
      "position": "inherit",
      "color": `${colors.textPrimary} !important`,
      ".ms-MessageBar-content": {
        "background": `${colors.backgroundLight} !important`,
        "color": `${colors.textPrimary} !important`,
        "alignItems": "center",
        ".ms-MessageBar-text": {
          fontSize: typography.fontSizeSm,
          lineHeight: typography.lineHeightSm,
        },
      },
    },
  },
  "editPanel": {
    root: {
      "label": {
        "fontWeight": "normal",
        ":after": {
          color: "var(--color-fg-1)",
        },
      },
      ".ms-TextField-description": {
        color: colors.textPrimary,
        fontSize: typography.fontSizeXs,
      },
      "marginBottom": spacing.xl,
    },
  },
  "iconButtonStyle": {
    icon: { color: colors.textPrimary },
    checkDisabled: (state: boolean) => ({
      color: state === true ? "var(--color-fg-disabled)" : colors.textPrimary,
    }),
  },
  "iconButtonDisabledStyle": {
    icon: { color: colors.textDisabled },
  },
  "linkStyles": {
    root: {
      color: colors.textPrimary,
      display: "flex",
      alignItems: "center",
      selectors: {
        ":active, :hover, :focus": {
          color: "black",
          fontWeight: "bold",
        },
      },
    },
  },
  "textFieldStyle": {
    root: {
      maxWidth: "400px",
      marginBottom: spacing.sm,
    },
    revealIcon: {
      color: colors.textPrimary,
    },
    suffix: {
      padding: "0px",
    },
    wrapper: {
      ".ms-Label": {
        fontWeight: typography.fontWeightNormal,
        size: typography.fontSizeSm,
        lineHeight: typography.lineHeightMd,
      },
    },
  },
  "errorText": {
    root: {
      color: colors.error,
    },
  },

  "textFieldDynamicWidthStyle": {
    root: {
      marginBottom: spacing.sm,
      marginRight: spacing.xs,
    },
    revealIcon: {
      color: colors.textPrimary,
    },
    suffix: {
      padding: "0px",
    },
    wrapper: {
      ".ms-Label": {
        fontWeight: typography.fontWeightNormal,
        size: typography.fontSizeSm,
        lineHeight: typography.lineHeightMd,
      },
    },
  },

  "dropdownCaretDownStyle": {
    caretDown: {
      color: colors.textPrimary,
    },
  },

  "dropdownStyle": {
    root: {
      maxWidth: "400px",
      marginBottom: spacing.sm,
    },
    label: {
      fontWeight: typography.fontWeightNormal,
      size: typography.fontSizeSm,
      lineHeight: typography.lineHeightMd,
    },
    caretDown: {
      color: colors.textPrimary,
    },
  },
  "dropdown350": {
    root: {
      maxWidth: "350px",
      marginBottom: spacing.sm,
    },
    label: {
      fontWeight: typography.fontWeightNormal,
      size: typography.fontSizeSm,
      lineHeight: typography.lineHeightMd,
    },
    caretDown: {
      color: colors.textPrimary,
    },
  },

  "dropdownDynamicWidthStyle": {
    root: {
      marginBottom: spacing.sm,
      marginRight: spacing.xs,
    },
    label: {
      fontWeight: typography.fontWeightNormal,
      size: typography.fontSizeSm,
      lineHeight: typography.lineHeightMd,
    },
    caretDown: {
      color: colors.textPrimary,
    },
  },

  "buttonStyles": {
    root: { marginRight: spacing.xs, marginTop: spacing.xs, marginBottom: spacing.xs },
  },
  "confirmationCancelButton": {
    root: {
      padding: `${spacing.xs} ${spacing.lg}`,
    },
  },
  "confirmationOkButton": {
    root: {
      padding: `${spacing.xs} ${spacing.lg}`,
      marginRight: spacing.xxs,
      marginTop: spacing.xs,
    },
  },

  "confirmationDialog": {
    root: {
      ".ms-Dialog-main": {
        minHeight: 0,
      },
      ".ms-dialogMainOverride": {
        maxHeight: "500px !important",
        minHeight: "172px !important",
        maxWidth: "340px !important",
        minWidth: "400px !important",
      },
      ".ms-wideDialogMainOverride": {
        maxWidth: "600px !important",
      },
      ".ms-Modal-scrollableContent": {
        display: "flex",
      },
      ".ms-dialogContentOverride": {
        display: "flex",
        flexDirection: "column",
      },
      ".ms-Dialog-title": {
        padding: `${spacing.xxl} 0 ${spacing.xs} ${spacing.xxl}`,
      },
      ".ms-Dialog-button--close": {
        "width": "unset",
        "height": "unset",
        "padding": spacing.xs,
        ".ms-Button-icon": {
          margin: "0",
        },
      },
      ".ms-Dialog-inner": {
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        padding: `0 ${spacing.xxl} ${spacing.xxl}`,
      },
      ".ms-Button": {
        minWidth: "unset",
      },
      ".ms-Dialog-actionsRight": {
        "display": "flex",
        "gap": spacing.xs,
        "justifyContent": "end",
        "marginRight": "unset",
        ".ms-Dialog-action": {
          "margin": "unset",
          ".ms-Button": {
            "margin": "unset",
            ".ms-Button-label": {
              margin: "unset",
            },
          },
        },
      },
    },
    topButton: {
      padding: `${spacing.xs} ${spacing.xs} 0 0`,
    },
  },
  "checkBoxStyles": {
    root: { marginTop: spacing.xs, marginBottom: spacing.xs },
    label: {
      fontWeight: typography.fontWeightNormal,
      size: typography.fontSizeSm,
      lineHeight: typography.lineHeightMd,
    },
  },

  "choiceGroupStyles": {
    root: {
      ".ms-ChoiceField-field": {
        fontWeight: typography.fontWeightNormal,
        size: typography.fontSizeSm,
        lineHeight: typography.lineHeightMd,
      },
    },
    flexContainer: {
      display: "flex",
      width: "35%",
      justifyContent: "space-between",
    },
    label: {
      fontWeight: typography.fontWeightSemibold,
      size: typography.fontSizeSm,
      lineHeight: typography.lineHeightMd,
    },
  },

  "subTitleStyles": {
    root: { marginTop: spacing.xs, marginBottom: spacing.xs },
  },

  "fluentSpinnerStyle": {
    root: {
      marginRight: spacing.sm,
      fontSize: typography.fontSizeXl,
      lineHeight: "normal",
    },
    circle: {
      borderTopColor: colors.primary,
      borderBottomColor: colors.primaryLight,
      borderLeftColor: colors.primaryLight,
      borderRightColor: colors.primaryLight,
      height: typography.fontSizeXl,
      width: typography.fontSizeXl,
    },
  },

  "box": {
    marginBottom: "0px",
    borderTop: "none",
    height: "auto",
    padding: spacing.xxxl,
  },

  "nameFieldGap": {
    root: { marginBottom: spacing.lg },
  },

  "textFieldGap": {
    root: { marginBottom: spacing.md },
  },

  "textAreaGap": {
    root: { marginBottom: spacing.lg },
  },

  "enrichmentContainer": {
    height: "auto",
    backgroundColor: colors.background,
  },
  "ml15": {
    marginLeft: "15px",
  },
  "mt10": {
    marginTop: spacing.sm,
  },
  "tooltipHost": {
    content: {
      fontSize: typography.fontSizeXs,
    },
  },
  "clickable": {
    cursor: "pointer",
  },
  "hiddenBorderInput": {
    border: "hidden",
  },
  "hiddenBorderInput:focus": {
    border: "hidden",
  },
  "pathSelectorFileItemStyle": {
    root: {
      padding: 1,
      borderBottom: "1px solid transparent",
      fontSize: typography.fontSizeMd,
    },
  },
  "outlineNone": {
    outline: 0,
  },
  "fixedTopNotificationBar": (width: string | number, spinner: boolean) => ({
    root: {
      "position": "fixed",
      "top": "50px",
      "zIndex": 999,
      "width": width,
      "background": spinner ? colors.background : "transparent",
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      "left": document?.querySelector("#sky-sidebar")?.offsetWidth,
      "right": 0,
      "@media(max-width: 600px)": {
        left: "0 !important",
        width: "100%",
      },
    },
  }),
  "messageStack": (success: boolean) => ({
    root: {
      "background": success ? `${colors.success} !important` : `${colors.error} !important`,
      "color": `${colors.textPrimary} !important`,
      ".ms-MessageBar-content": {
        background: `${colors.success} !important`,
        color: `${colors.textPrimary} !important`,
      },
    },
  }),
  ".successMessageBar": {
    "background": `${colors.success} !important`,
    "color": `${colors.textPrimary} !important`,
    ".ms-MessageBar-content": {
      background: `${colors.success} !important`,
      color: `${colors.textPrimary} !important`,
    },
  },
  ".errorMessageBar": {
    "background": `${colors.error} !important`,
    "color": `${colors.textPrimary} !important`,
    ".ms-MessageBar-content": {
      background: `${colors.error} !important`,
      color: `${colors.textPrimary} !important`,
    },
  },
  "multipleDeleteButton": {
    root: {
      padding: 0,
      height: "44px",
      button: {
        padding: `0 ${spacing.sm}`,
      },
    },
    rootDisabled: {
      cursor: "not-allowed",
    },
    iconDisabled: {
      color: "B3B3B3",
    },
  },
  "skyPointHeaders": {
    root: {
      minWidth: "100%",
      position: "sticky",
      top: 0,
      zIndex: 999,
    },
  },
  "infoMsg": {
    height: "40px",
    paddingTop: "9px",
  },
};

export { colors, spacing, typography };
